import ScrollContainer from 'components/scrollContainer/scrollContainer'
import AnchorButtonContext from 'contexts/anchorButton'
import { useCounterContext } from 'contexts/counter'
import { useHeadbandContext } from 'contexts/headband'
import { useContext, useEffect } from 'react'
import InfosRh from './infosRh/infosRh'
import ReglementInterieur from './reglementInterieur/reglementInterieur'
export default function VosInformationsRH() {
   const { setCounter, counterDefault } = useCounterContext()
   const { setHeadband } = useHeadbandContext()
   const { setAnchorButton } = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setAnchorButton([])
      setHeadband('Informations RH<br>et intégration')
   }, [])
   return (
      <ScrollContainer>
         <div className='page' style={{ background: 'white'}}>
            <InfosRh />
            <ReglementInterieur />
         </div>
      </ScrollContainer>
   )
}
